import React, { useState } from "react";
import TextareaAutosize from "react-textarea-autosize";
import CkEditor from "../../CkEditor/CkEditor";

const FreeText = (props) => {
  const { handleFocus, setter, type, index, data, isEditable } = props;

  const [state, setState] = useState(data);

  // propagate synchronously so the parent always has the latest value before a blur-triggered save fires
  const handleChangeText = (ev, value) => {
    const newState = { ...state, text: value };
    setState(newState);
    setter(type, newState, index);
  };

  const handleChangeTitle = (ev) => {
    const newState = { ...state, title: ev.target.value };
    setState(newState);
    setter(type, newState, index);
  };

  return (
    <div className="fieldContainer">
      <div className="fieldHeader">
        <div className="fieldTitle">
          {isEditable ? (
            <TextareaAutosize
              onChange={handleChangeTitle}
              value={!!state.title ? state.title : data.title}
              placeholder="Escreva aqui o seu título"
              onFocus={() => handleFocus(true)}
              onBlur={() => handleFocus(false)}
            />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: data.title }} />
          )}
        </div>
      </div>

      <div className="editorArea">
        {isEditable ? (
          <CkEditor
            key={`freetext-${index}-${data.id || index}-edit`}
            onChange={handleChangeText}
            onFocus={() => handleFocus(true)}
            onBlur={() => handleFocus(false)}
            data={data}
          />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data.text }} />
        )}
      </div>
    </div>
  );
};

export default FreeText;
